/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { getProp } from "@insite/mobius/utilities";
import { slashText } from "@monsma/App/WidgetExtensions/MyListsDetails/MyListsDetailsExtension";
import { actionStyles } from "@monsma/Overrides/Widgets/MyListsDetails/MyListsDetailsActions";
import Edit from "@monsma/XDL/Icons/Edit";
import Print from "@monsma/XDL/Icons/Print";
import ShareAlt from "@monsma/XDL/Icons/ShareAlt";
import Trash from "@monsma/XDL/Icons/Trash";
import { css } from "styled-components";

const linkButtonCommonStyles = (iconSrc: any) => ({
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        margin-left: 30px;
        width: auto;
        flex-wrap: nowrap;
    `,
    icon: {
        iconProps: {
            src: iconSrc,
            color: "common.ui5",
            size: 12,
            css: css`
                margin-right: 5px;
            `,
        },
    },
    typographyProps: {
        size: 12,
        css: css`
            line-height: 12px;
            white-space: nowrap;
        `,
    },
});

actionStyles.printButton = linkButtonCommonStyles(Print);
actionStyles.scheduleButton = linkButtonCommonStyles(Trash);
actionStyles.editButton = linkButtonCommonStyles(Edit);
actionStyles.shareButton = linkButtonCommonStyles(ShareAlt);

(actionStyles as any).slashText = {
    ...slashText,
    css: css`
        ${slashText?.css};
        padding-right: 0;
        padding-left: 30px;
    `,
};
actionStyles.wideHidden = {
    below: "md",
    css: css`
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    `,
};

actionStyles.wideHidden = {
    below: "md",
    css: css`
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    `,
};

actionStyles.nameText = {
    variant: "h2",
    as: "h1",
    ellipsis: true,
    color: "common.ui1",
    css: css`
        flex: 1;
    `,
};

actionStyles.narrowHidden = {
    above: "sm",
    css: css`
        display: inline-flex;
        align-items: center;
    `,
};

actionStyles.removeSelectedButton = {
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
            margin: 0;
        `,
    },
    css: css`
        margin-left: 30px;
    `,
    sizeVariant: "small",
    variant: "secondary",
};

actionStyles.addListButton = {
    sizeVariant: "small",
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
            margin-bottom: 0;
        `,
    },
    css: css`
        padding: 0 15px;
        margin-left: 30px;
    `,
};

actionStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    `,
};

actionStyles.nameText = {
    variant: "h2",
    as: "h1",
    ellipsis: true,
    css: css`
        margin-bottom: 0;
        margin-right: 5px;
    `,
};

actionStyles.overflowMenu = {
    mergeCss: true,
    cssOverrides: {
        menu: css`
            overflow-y: auto;
        `,
    },
};

actionStyles.nameWrapper = {
    css: css`
        display: flex;
        gap: 10px;
    `,
};
